<template>
  <div>
    <div class="header">
      <div class="container">
        <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
          <ul>
            <li><router-link to="/">Inicio</router-link></li>
            <li class="is-active">
              <a href="#" aria-current="page">Mi perfil</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="container">
      <div class="main">
        <h2 class="title">
          Mi perfil
        </h2>
        <hr />
        <div class="columns">
          <div class="column is-4">
            <div class="card">
              <div class="card-header">
                <div class="card-header-title">
                  Información personal
                </div>
              </div>
              <div class="card-content">
                <div>Nombre emprendedor</div>
                <div>{{ user.name }} {{ user.lastname }}</div>
                <div>RUN</div>
                <div>{{ user.rut }}</div>
                <div>Correo electrónico</div>
                <div>{{ user.email }}</div>
              </div>
            </div>
          </div>
          <div class="column is-8">
            <h3 class="title is-5 underlined">Mis emprendimientos</h3>

            <my-ventures></my-ventures>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.header {
  background: linear-gradient(90deg, #fb5f3d 0%, #ffa63d 71.55%);
  color: white;
  height: 208px;
  padding: 30px;
  a {
    color: white;
  }
  .breadcrumb {
    li {
      a {
        color: white;
      }
      + li {
        &::before {
          color: white;
        }
      }
      &.is-active {
        a {
          color: white;
        }
      }
    }
  }
}
.main {
  background: white;
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.12);
  padding: 5%;
  margin-top: -120px;
}
</style>
<script>
import MyVentures from "@/components/MyVentures";

export default {
  components: {
    MyVentures
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  metaInfo: {
    title: "Perfil"
  }
};
</script>
